module.exports = __webpack_public_path__ + "img/A904.0c047664.jpg";